import * as React from 'react';
import { usePerformAction } from 'react-remote-data-hooks';
import api from '../../../../api';
import {
  convertPascalCaseToWords,
  FollowupSettings,
  FollowupActivitiesOfStage,
  LeadStage,
} from '../../../../core';
import { useAppSettings } from '../../../../core/hooks/useAppSettings';
import UpdateForm from './UpdateForm';
import { useStateWithCallbackLazy } from 'use-state-with-callback';

interface IFollowupSettingsProps {
  data?: FollowupSettings;
  reload?: () => void;
}

const FollowupSettingsTab: React.FunctionComponent<IFollowupSettingsProps> = (
  props
) => {
  const appSettings = useAppSettings(api.settings);

  const [editModalOpen, setEditModalOpen] = useStateWithCallbackLazy<{
    isOpen?: boolean;
    data?: FollowupActivitiesOfStage;
    stage?: LeadStage;
  }>({});

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: FollowupActivitiesOfStage) =>
      api.settings.updateFollowupSettings({
        ...data,
        stage: editModalOpen.stage,
      }),
    () => {
      setEditModalOpen({}, () => {
        props.reload?.();
        appSettings.reload();
      });      
    }
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Followup Settings</h4>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Stage
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(LeadStage).map((key) => {
                const stageData = props.data?.stages?.find(
                  (x) => x.stage === key
                );
                return (
                  <tr
                    onClick={() =>

                      setEditModalOpen({}, () => {
                        setEditModalOpen({
                          isOpen: true,
                          data: stageData,
                          stage: key as LeadStage,
                        }, () => {
                          // console.log("model closed")
                        });
                      })

                      
                    }
                    className="cursor-pointer"
                  >
                    <td>
                      {convertPascalCaseToWords(key)}
                      {!stageData && <span className="dot dot--red"></span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen?.isOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={editModalOpen.data}
              onCancel={() => 
                setEditModalOpen({}, () => {
                  // console.log("model closed")
                })
              }
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default FollowupSettingsTab;
